<template>
  <Modal>
    <template v-slot:header>
      {{ $t ('TWO_FACTOR_AUTHENTICATION_disableTitle') }}
    </template>

    <template v-slot:body>
      <div class="bodyContainer">
        <div class="imagen">
          <img src="../../images/sesion_activa.png" width="40" />
        </div>
        <div class="texto">{{ $t ('TWO_FACTOR_AUTHENTICATION_disableConfirm') }}</div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="footerContainer">
        <div>
          <el-button type="primary" @click="onDesactivate2FA" :loading="desactivando2FA">{{ $t ('TWO_FACTOR_AUTHENTICATION_disableBtn') }}</el-button>
          <el-button type="default" @click="onCloseModal(false)">{{ $t('GENERAL_cancelBtn') }}</el-button>
        </div>
      </div>

    </template>
  </Modal>
</template>

<script>
  import { showError, showSuccess } from "../Mensaje";
  import Modal from '../Modal/index.vue'
  export default {
    name: 'Disable2FAModal',
    components: { Modal },
    props: {
      onCloseModal: Function,
      username: String
    },
    data() {
      return {
        desactivando2FA: false
      }
    },
    methods: {
      onDesactivate2FA() {

        this.desactivando2FA = true
        const payload = {
          usuario: this.username,
        }
        this.$store.dispatch('sesion/desactivarTOTP',payload)
        .then((response) => {
          if(response === 0){
            showSuccess(this.$t('TWO_FACTOR_AUTHENTICATION_disableSuccess'));
            this.confirmDesactivate2FA();
          }else{
            showError(this.$t('TWO_FACTOR_AUTHENTICATION_disableError'));
          }
          this.desactivando2FA = false;
          this.closeModal();
        })
        .catch(() => {
          this.desactivando2FA = false
        })
      },
      closeModal() {
        this.onCloseModal(false);
      },
      confirmDesactivate2FA() {
        this.onCloseModal(true);
      } 
    }
  }

</script>

<style scoped>

 .bodyContainer {
    display: inline-block;
    width: 100%;
  }

  .bodyContainer .imagen {
    width: 40px; 
    float: left
  }

  .bodyContainer .texto {
    text-align: left;
    padding: 2px 0px;
    width: calc(100% - 60px);
    float: right;
  }

  .footerContainer {
    text-align: right;
  }

  .loaderContainer {
    display: inline-block;
    margin-right: 40px;
    padding: 18px 0px;
  }

  @media(max-width: 425px) 
  {
    .footerContainer .el-button {
      width: 100%;
    }

    .footerContainer .el-button:last-child {
      margin-top: 10px;
      margin-left: 0px;
    }
  }

</style>